import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import {
  FilterAccordion,
  FilterAccordionSummary,
  FilterAccordionDetails,
  BedroomButtonContainer,
  BedroomButton,
  Divider
} from '../styledComponents';
import { ExpandMoreIcon } from './ExpandMoreIcon';
import { bedroomOptions } from '../constants/filterConstants';

interface BedroomSectionProps {
  isExpanded: boolean;
  isVisible: boolean;
  onToggle: (event: React.MouseEvent) => void;
  selectedBedrooms?: string | null;
  onBedroomSelect?: (bedroom: string | null) => void;
  onCollapseAfterSelect?: () => void;
}

export const BedroomSection: React.FC<BedroomSectionProps> = ({
  isExpanded,
  isVisible,
  onToggle,
  selectedBedrooms,
  onBedroomSelect,
  onCollapseAfterSelect,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleBedroomSelect = (bedroom: string) => {
    const newValue = selectedBedrooms === bedroom ? null : bedroom;
    onBedroomSelect?.(newValue);
    
    if (onCollapseAfterSelect) {
      setTimeout(() => {
        onCollapseAfterSelect();
      }, 150);
    }
  };

  const selectedOption = bedroomOptions.find(option => option.value === selectedBedrooms);
  const selectedOptionLabel = selectedOption ? selectedOption.label : null;

  if (!isVisible) return null;

  return (
    <>
      <FilterAccordion className={isExpanded ? 'expanded' : ''}>
        <FilterAccordionSummary 
          className={isExpanded ? 'expanded' : ''}
          onClick={onToggle}
        >
          <Typography className="section-title" variant="subtitle1" fontWeight="medium">
            {isMobile && selectedOptionLabel ? (
              <>
                <span style={{ color: '#919192' }}>{t('bedroom')}</span>
                <span style={{ color: '#000000', fontWeight: 400 }}> : {selectedOptionLabel}</span>
              </>
            ) : (
              t('bedroom')
            )}
          </Typography>
          <ExpandMoreIcon className="expand-icon" />
        </FilterAccordionSummary>
        {isExpanded && (
          <FilterAccordionDetails>
            <BedroomButtonContainer>
              {bedroomOptions.map((option) => (
                <BedroomButton
                  key={option.value}
                  className={selectedBedrooms === option.value ? 'selected' : ''}
                  onClick={() => handleBedroomSelect(option.value)}
                >
                  {option.label}
                </BedroomButton>
              ))}
            </BedroomButtonContainer>
          </FilterAccordionDetails>
        )}
      </FilterAccordion>
      <Divider />
    </>
  );
}; 